import { ITooltip, Tooltip as ReactTooltip } from "react-tooltip";
import { clsx } from "clsx";

export default function Tooltip({
  className,
  arrow = false,
  ...rest
}: Omit<ITooltip, "noArrow"> & { arrow?: boolean }) {
  return (
    <ReactTooltip
      disableStyleInjection
      closeOnEsc
      // This avoids us having to put separate tooltips inside scrolling containers
      closeOnScroll
      closeOnResize
      // a11y: We don't care about clickable but it should not dismiss when it is hovered over
      clickable
      delayShow={500}
      noArrow={!arrow}
      className={clsx(
        "vst-tooltip",
        arrow && "vst-tooltip-option-arrow",
        className
      )}
      offset={arrow ? 10 : 4}
      opacity={1}
      {...rest}
    />
  );
}
